<template>
    <div>
        <v-card>
            <v-card-title>SOLICITUD RETIRO DE MATERIALES N° {{ data.nro }}</v-card-title>
            <v-card-text>
                <!-- <botonera 
                    :botones="botones" 
                    alinear="right" 
                    @crear="agregarSolicitud"
                >
                </botonera> -->
                <!-- <v-text-field
                    label="Nombre Wellboat"
                    placeholder="Nombre Wellboat" 
                    v-model="wellboat_filtred"
                    style="max-width:180px"
                /> -->
                <div class="d-flex justify-end">


                    <v-btn color="blue" dark @click="volver()">
                        Volver
                    </v-btn>
                </div>

                <div class="flex">
                    <v-btn style="width:200px;" class="ma-2 ml-auto mr-5 mb-5" color="success"
                        @click="guardarSolicitudRetiro()">
                        Guardar
                        <template v-slot:loader>
                            <span>Loading...</span>
                        </template>
                    </v-btn>
                </div>

                <v-alert border="left" outlined text :type="alert.tipo" v-if="alert.mostrar">
                    <v-row>
                        <v-col>
                            <h4>{{ alert.mensaje }}</h4>
                        </v-col>
                        <v-col class="text-right">
                            <v-btn :color="alert.color_boton" elevation="2" small dark
                                @click="cerrar_alert">Cerrar</v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-if="alert.errores.length > 0">
                        <v-col>
                            <ul>
                                <li v-for="e in alert.errores" :key="e">{{ e }}</li>
                            </ul>
                        </v-col>
                    </v-row>
                </v-alert>
            </v-card-text>
        </v-card>
        <div class="card">
            <div class="card-header card-header-primary card-header-icon">
                <div :class="`card-icon ${color_icono}`">
                    <i class="material-icons" v-show="icono">{{ icono }}</i>
                </div>
                <h4 class="card-title">
                    <div class="row">
                        <div class="col-md-6">
                            ITEMS DE SOLICITUD DE RETIRO
                        </div>
                    </div>
                </h4>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <v-autocomplete style="margin-top:10px" :items="solicitantes" item-text="name" item-value="id"
                            outlined dense chips small-chips label="Recibe"
                            v-model="data.users_id_recepciona"></v-autocomplete>
                    </div>
                </div>
                <spinner v-if="spinner"></spinner>
                <v-simple-table :height="table_height">
                    <template v-slot:default>
                        <thead>
                            <tr>

                                <th class="text-center">WELLBOAT</th>
                                <th class="text-center">FOLIO</th>
                                <th class="text-center">FECHA SOLICITUD</th>
                                <th class="text-center">ENCARGADO ÁREA</th>
                                <th class="text-center">ÁREA</th>
                                <th class="text-center">CATEGORÍA</th>
                                <th class="text-center">ITEM</th>
                                <th class="text-center">DESCRIPCIÓN</th>
                                <th class="text-center">CANTIDAD SOLICITADA</th>
                                <th class="text-center">ARCHIVO ADJUNTO</th>
                                <th class="text-center">CANTIDAD APROBADA</th>
                                <th class="text-center">CANTIDAD AUTORIZADA</th>
                                <th class="text-center">ESTADO</th>
                                <!--<th class="text-center acciones-column2">ACCIONES</th>-->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in items" :key="index" class="text-center">

                                <td>
                                    {{ item.wellboat }}
                                </td>
                                <td>
                                    {{ `${item.centro_costo}-${item.folio}` }}
                                </td>
                                <td>
                                    {{ item.fecha_solicitud }}
                                </td>
                                <td>
                                    {{ item.nombre_encargado }}
                                </td>
                                <td>
                                    {{ item.area }}
                                </td>
                                <td>
                                    {{ item.categoria }}
                                </td>
                                <td>
                                    {{ item.material_codigo }}
                                </td>
                                <td>
                                    {{ item.descripcion }}
                                </td>
                                <td>
                                    {{ item.cantidad | formatear_miles }}
                                </td>
                                <td>
                                    <a @click="downloadFile(item.archivo)" target="_blank" class="ma-2">
                                        <v-icon large v-if="
                                            item && item.archivo && item.archivo.includes('.pdf')
                                        " style="color:#ef233c">
                                            mdi-file-pdf-box
                                        </v-icon>
                                        <v-icon large v-else-if="item.archivo != null" style="color:#52b788">
                                            mdi-file-image
                                        </v-icon>
                                    </a>
                                </td>
                                <td>
                                    {{ item.revisor_cantidad_aprob | formatear_miles }}
                                </td>
                                <td>
                                    {{ item.aprobador_cantidad_aprob | formatear_miles }}
                                </td>
                                <td>
                                    {{ item.estado }}
                                </td>
                                <!--<td>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <a class="ma-2" @click="rechazarSolicitud(index)" v-bind="attrs" v-on="on">
                                                <v-icon large color="red">
                                                    mdi-alpha-x-circle
                                                </v-icon>
                                            </a>
                                        </template>
            <span>Rechazar Solicitud</span>
            </v-tooltip>
            </td>-->
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </div>

        </div>

        <v-alert v-if="empty_data" border="right" color="blue-grey" dark>
            No hay solicitudes en revisión...
        </v-alert>

        <v-snackbar v-model="snackbar" :timeout="5000" :color="color">
            {{ validation_message }}

            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                    Cerrar
                </v-btn>
            </template>
        </v-snackbar>


    </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
export default {
    data: () => ({
        id: null,
        table_height: 550,
        spinner: false,
        color_icono: "azul",
        icono: "list",
        data_header: null,
        activePicker: null,
        // encargados: [],
        items: [],
        solicitantes: [],
        validation_message: "",
        color: "green",
        snackbar: false,
        empty_data: false,
        data: {},
        alert: {
            mostrar: false,
            tipo: "",
            color_boton: "",
            mensaje: "",
            errores: [],
        },
    }),
    created() {
        this.id = this.$route.params.id;
        this.loadSolicitudRetiro();
        this.loadSolicitanteAdministrativo();
    },
    mounted() {
    },
    computed: {
        ...mapState([
            "loading",
            "base_url",
            "headers",
            "headers_file",
            "wellboat",
            "user",
            "storage_url",
        ]),

    },
    methods: {
        downloadFile(archivo) {
            const link = `${this.storage_url}solicitudes/${archivo}`;
            console.log(link);
            window.open(link);
        },
        cerrar_alert() {
            this.alert.mostrar = false;
            this.alert.tipo = "";
            this.alert.color_boton = "";
            this.alert.mensaje = "";
            this.alert.errores = [];
        },
        async loadSolicitudRetiro() {
            this.spinner = true;
            this.mostrarLoading("Cargando información...");
            let url = `${this.base_url}solicitudes_retiros/${this.id}`;

            await this.axios
                .get(url, this.headers)
                .then((response) => {
                    this.data = response.data.data;
                    this.items = response.data.items;
                    this.ocultarLoading();
                })
                .catch((error) => {
                    console.log(error);
                });
            this.spinner = false;
        },

        async loadSolicitanteAdministrativo() {
            this.spinner = true;
            this.mostrarLoading("Cargando información...");
            let url = `${this.base_url}solicitantes_administrativos`;

            await this.axios
                .get(url, this.headers)
                .then((response) => {
                    this.solicitantes = response.data.data;
                    this.ocultarLoading();
                })
                .catch((error) => {
                    console.log(error);
                });
            this.spinner = false;
        },

        async guardarSolicitudRetiro() {
            this.spinner = true;
            this.mostrarLoading("Guardando...");

            const url = `${this.base_url}solicitudes_retiros`;

            await this.axios
                .post(url, this.data, this.headers)
                .then((response) => {
                    console.log(response);
                    //this.data = response.data.data;
                    //this.items = response.data.items;
                    this.ocultarLoading();
                })
                .catch((error) => {
                    console.error(error);
                    this.ocultarLoading();
                });

            this.spinner = false;
        },

        async rechazarSolicitud(index) {
            this.spinner = true;
            let url = `${this.base_url}items/${this.items[index].id}`;
            let data = {
                estados_solicitudes_id: 6,
            };

            this.items[index].id === null
                ? this.items.splice(index, 1)
                : this.$confirm(
                    "¿Estás seguro de que deseas rechazar esta solicitud?"
                ).then(async (res) => {
                    res &&
                        new Promise(() => {
                            this.axios
                                .put(url, data, this.headers)
                                .then((response) => {
                                    response.status === 200 &&
                                        new Promise(() => {
                                            this.alert.mostrar = true;
                                            this.alert.tipo = "success";
                                            this.alert.color_boton = "green";
                                            let wellboat = this.items[index].wellboat
                                                ? `wellboat ${this.items[index].wellboat}`
                                                : "";
                                            this.alert.mensaje = `Se ha rechazado la solicitud ${wellboat} con folio ${this.items[index].folio}`;
                                            this.items.splice(index, 1);
                                        });
                                    this.ocultarLoading();
                                })
                                .catch((error) => {
                                    console.log(error);
                                });
                        });
                });
            this.spinner = false;
        },



        volver() {
            if (this.$route.path !== "/solicitud_retiros") {
                this.$router.push({ path: "/solicitud_retiros" });
            }
        },

        showSnackBar(message = "", error = false) {
            if (error) {
                this.color = "red";
                this.validation_message = message || "Ha ocurrido un error";
            } else {
                this.color = "green";
                this.validation_message = message || "Ejecutado exitosamente!";
            }
            this.snackbar = true;
        },





        ...mapMutations(["mostrarLoading", "ocultarLoading"]),
    },
};
</script>
<style scoped>
.acciones-column2 {
    width: 150px;
}

th {
    background-color: #355f94 !important;
    color: #fff !important;
    border: 1px solid #fff;
}
</style>
